import React from 'react';
import styled from '@emotion/styled';
import TextField from '@mui/material/TextField';
import { Box, Typography } from '@mui/material';

const Container = styled('div')`
	width: 100%;
	padding: 0 10px;
	background: #fff;
	border-radius: 5px;
	border: 1px solid #b7b8bf;
`;

const Row = styled('div')`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	width: 100%;
`;

const CoinContainer = styled('div')`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	background: #275ff11a;
	border-radius: 5px;
	padding: 4px 10px;
`;

export const AmountInputBox: React.ComponentType<{
	text: string;
	leftTxt?: string;
	rightTxt?: string;
	onChange?(text: string): void;
	currency: { icon: string; name: string };
}> = ({ text, onChange, leftTxt, currency, rightTxt }) => {
	const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const value = event.target.value;
		// Regular expression to allow only numbers with or without decimals
		const regex = /^[0-9]*\.?[0-9]*$/;
		if (regex.test(value)) {
			onChange?.(value);
		}
	};

	return (
		<>
			<Container>
				<Row>
					<TextField
						variant="outlined"
						placeholder="Enter amount"
						sx={{
							'& .MuiOutlinedInput-root': {
								'& fieldset': {
									border: 'none',
								},
							},
						}}
						inputProps={{
							inputMode: 'numeric',
							pattern: '[0-9]*',
							style: { fontSize: '16px' }, // Set input text font size to 16px
						}}
						value={text}
						onChange={handleInputChange}
					/>
					<CoinContainer>
						<img
							src={currency.icon}
							height={24}
							width={24}
							alt="USDC"
						/>
						<Box width={10} />
						<Typography
							variant="caption"
							color="#000"
							sx={{ fontSize: '16px' }} // Set currency name text size to 16px
						>
							{currency.name.toUpperCase()}
						</Typography>
					</CoinContainer>
				</Row>
			</Container>
			<Box height={8} />
			<Row>
				<Typography
					variant="body1"
					color="#666677"
					style={{ marginLeft: 14, fontSize: '16px' }} // Apply font size to left text
				>
					{/* {leftTxt || ''} */}
				</Typography>
				<Typography
					variant="caption"
					color="#666677"
					style={{ marginLeft: 14, fontSize: '16px' }} // Apply font size to right text
				>
					{/*In vault {rightTxt || ''}*/}
				</Typography>
			</Row>
		</>
	);
};
